import React from "react";
import { Content } from "@iventis/translations";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Body1, Header1, sectionalMargin, styled } from "@iventis/styles";
import { LoadingComponent } from "@iventis/components";
import { Container } from "./digital-twin-components";

/**
 * A loading component for the digital twin.
 */
export const DigitalTwinRestartingComponent: React.FunctionComponent = () => {
    const translate = useIventisTranslate();

    return (
        <Container>
            <StyledLoading />
            <Header1>{translate(Content.map8.digitalTwin.restarting.header)}</Header1>
            <Body1>{translate(Content.map8.digitalTwin.restarting.message)}</Body1>
        </Container>
    );
};

const StyledLoading = styled(LoadingComponent)`
    padding: ${sectionalMargin};
    width: auto;
    height: auto;
`;
